import { SessionStorageManager } from '@helpers/utils';

export const SESSION_STORAGE_NAMESPACE = 'web';

export const SESSION_STORAGE_KEY = {
  DASHBOARD_WELCOME_HERO_OPEN: 'dashboardWelcomeHeroOpen',
  IMPERSONATED_TOKEN: 'impersonatedToken',
  SIDEBAR_OPEN: 'sidebarOpen',
  SESSION_ID: 'sessionId',
  COMPANY_ID: 'companyId',
} as const;

export const ssManager = new SessionStorageManager(SESSION_STORAGE_NAMESPACE, SESSION_STORAGE_KEY);
